 /**
 * [Soumission du formulaire de demande de documentation en ajax - gestion du loader et du message de retour]
 * @return -
 */
function ajaxSubmitFormDemandeDocumentation(envoiEventAnalyticsActif = false) {
    $('#demande-documentation').on('submit', function(event) {
        event.preventDefault();
        // Objet du formulaire
        var $this = $(this);
        // Recuperation des valeurs
        var data = $this.serialize();
        $.ajax({
            url: $this.attr('action'),
            type: $this.attr('method'),
            data: data,
            beforeSend: function() {
                // Affichage du loader + on masque le bouton
                $('#demande-documentation .loader').removeClass('hidden');
                $('#button-demande-document').addClass('hidden');

                // On rend visible les balises d'affichage d'erreur
                $('.errors-demande-document').empty();
                $('.errors-demande-document').addClass('hidden');
            },
            success: function(data) {
                //Si conversion
                // ga sera instancié si les cookies ont été autorisés via tarteaucitron
                if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'Formulaires', 'Telechargement', 'Telechargement-Brochure');
                }
                //Si conversion AdWords
                // window.triggerGoogletrackConversion sera instancié si les cookies ont été autorisés via tarteaucitron
                if (envoiEventAnalyticsActif && window.triggerGoogletrackConversion !== undefined) {
                    window.triggerGoogletrackConversion();
                }

                // Si le cookie talent_custom a été accepté
                if (tarteaucitron.state.talent_custom)
                {
                    tarteaucitron.user.talent_customShouldRun = true;
                    tarteaucitron.user.talentTracker = 'creacours';

                    tarteaucitron.services.talent_custom.js();
                }

                // Chargement du formulaire click2tel dans le conteneur caché
                $(".renseignement-etape.renseignement-etape2").html(data.remerciementHtml);
                // Transition : on détruit le conteneur formulaire demande de doc, on passe au conteneur Click2tel
                changerEtapeDemandeDocument($(".renseignement-etape.renseignement-etape1"), $(".renseignement-etape.renseignement-etape2"), $(".section-demande-documentation"));
            },
            error: function(error) {
                // Reaffichage du bouton + loader masqué
                $('#button-demande-document').removeClass('hidden');
                $('#demande-documentation .loader').addClass('hidden');
                // On rend visible les balises d'affichage d'erreur
                $('.errors-demande-document').removeClass('hidden');

                if (typeof error.responseJSON !== 'undefined') {
                    if ('csrf' in error.responseJSON) {
                        $('meta[name="csrf-token"]').attr('content', error.responseJSON.newCsrfToken[0]);
                        delete error.responseJSON.newCsrfToken;
                    }

                    if (error.responseJSON.success == false) {
                        errorMessage = 'Une erreur est survenue, merci de réessayer ultérieurement.';
                        $('.errors-demande-document.error-general').html(errorMessage);
                    }

                    // Liste des messages d'erreur
                    $.each(error.responseJSON, function(key, message) {
                        $('.errors-demande-document.error-'+key).html(message[0]);
                    });
                } else {
                    // Si erreur 500 côté back
                    errorMessage = 'Une erreur est survenue, merci de réessayer ultérieurement.';
                    $('.errors-demande-document.error-general').html(errorMessage);
                }
            }
        });
    });
}
window.ajaxSubmitFormDemandeDocumentation = ajaxSubmitFormDemandeDocumentation;



/**
 * [Permet de faire une transition entre 2 conteneurs]
 * @param  {[objet jQuery]} prevElement [objet jQuery du conteneur à faire disparaitre]
 * @param  {[objet jQuery]} nextElement [objet jQuery du conteneur à faire apparaitre]
 * @param  {[objet jQuery]} container [objet jQuery du conteneur contenant toutes les elements étapes]
 * @param  {[int]} length [durée de la transition]
 * @return -
 */
function changerEtapeDemandeDocument(currentElement, nextElement, container) {
    nextElement.css('position', 'absolute').css('visibility', 'hidden');

    var heightConteneur = (currentElement.height() > nextElement.height()) ? currentElement.height() : nextElement.height();

    container.height(heightConteneur);
    nextElement.css('display', 'none').css('visibility', 'visible');
    currentElement.css('position', 'absolute');
    // Transition des 2 contenus
    currentElement.fadeOut(400, function(){
        currentElement.css('position', 'relative');
        currentElement.empty();
    });
    nextElement.fadeIn(400, function(){
        nextElement.css('position', 'relative');
        container.css('height', 'auto');
    });


    // Scroll auto :haut de la section demande de doc
    var offsetDestination = ( $(".site-header #menutestScrollFix").lenght || $(".menu-fixe").length ) ? $(".section-demande-documentation").offset().top - 60 : $(".section-demande-documentation").offset().top;
    $('html, body').animate(
        { scrollTop: offsetDestination }, 500
    );
}

function gestionIndicatifPays(){
    // Gestion de l'indicateur pays en fonction du champs pays choisi
    $('#indicatif-telephone').text($('#form-pays').find(":selected").data('indictel'));
    $('#form-pays').on('change', function(e) {
        $('#indicatif-telephone').text($(e.currentTarget.selectedOptions).data('indictel'));
    });
}
window.gestionIndicatifPays = gestionIndicatifPays;
